export default "__VITE_ASSET__2DWA_O2v__"